import { render, staticRenderFns } from "./EmblaCarousel.vue?vue&type=template&id=46a90700&scoped=true"
import script from "./EmblaCarousel.vue?vue&type=script&lang=js"
export * from "./EmblaCarousel.vue?vue&type=script&lang=js"
import style0 from "./EmblaCarousel.vue?vue&type=style&index=0&id=46a90700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a90700",
  null
  
)

export default component.exports